import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

// Same component as dm-commerce-b2b-web (CustomMenuItem)
export const CustomMenuItem = styled(MenuItem)(() => ({
  backgroundColor: "transparent",
  borderRadius: "10px",
  fontWeight: 300,
  padding: "5px 8px",
  margin: "4px 10px",
  fontSize: "14px",
  fontFamily: "inherit",
  color: "var(--color-text)",
  "&:hover": {
    backgroundColor: "var(--color-primary-light) !important",
  },
  "&.Mui-selected": {
    backgroundColor: "var(--color-primary-light) !important",
  },
}));
